import { PHASE_ORDER, type CoinReason, type MatchPhase } from '@brochure/shared'

const KNOCKOUT_ROUND = /^knockout_round_(\d+)$/

/** Chiave i18n per una fase: le fasi con nome usano `phases.<fase>`, i turni dinamici condividono `phases.knockoutRound`. */
export function phaseKey(phase: MatchPhase): string {
  return KNOCKOUT_ROUND.test(phase) ? 'phases.knockoutRound' : `phases.${phase}`
}

/** Parametri per `phases.knockoutRound` ({{n}}); `undefined` per le fasi con nome. */
export function phaseParams(phase: MatchPhase): { n: number } | undefined {
  const match = KNOCKOUT_ROUND.exec(phase)
  return match ? { n: Number(match[1]) } : undefined
}

/** Chiave i18n per un motivo del registro monete. */
export function reasonKey(reason: CoinReason): string {
  return `coins.reasons.${reason}`
}

/** Ordina le fasi secondo `PHASE_ORDER` (girone → … → finale); le fasi non elencate restano in coda, nell'ordine originale. */
export function sortPhases(phases: readonly MatchPhase[]): MatchPhase[] {
  const rank = (phase: MatchPhase) => { const index = PHASE_ORDER.indexOf(phase); return index === -1 ? PHASE_ORDER.length : index }
  return phases
    .map((phase, index) => ({ phase, index }))
    .sort((a, b) => rank(a.phase) - rank(b.phase) || a.index - b.index)
    .map(({ phase }) => phase)
}

/** Data del torneo (YYYY-MM-DD) formattata per la lingua corrente; parsing manuale per non scivolare di
 * giorno nei fusi UTC-negativi (`new Date('YYYY-MM-DD')` legge mezzanotte UTC). */
export function formatTournamentDate(dateIso: string, lang: string): string {
  const [year, month, day] = dateIso.split('-').map(Number)
  return new Intl.DateTimeFormat(lang, { dateStyle: 'long' }).format(new Date(year, month - 1, day))
}
